module.exports = __webpack_public_path__ + "img/logo_v1_whitebg.5b9bf7e2.jpeg";